<template>
  <div class="submission-cases">
    <div class="pogs-list--panels__header">
      <label>Case No</label>
      <label>Patient</label>
      <label>Gyne Organ</label>
      <label>Organ Condition</label>
      <smd-btn pilled-o class="icon-text">
        <label dark>Approved</label>
        <smd-checkbox id="selectAll" value="checked"></smd-checkbox>
      </smd-btn>
    </div>
    <div class="pogs-list--panels compact">
      <div class="pogs-list__item"
           v-for="(c, key) in gyneCases"
           :key="key">

        <div><h3>{{c._id}}</h3></div>

        <div class="patient">
          <div class="patient-img">
            <div class="smd-profile-image m"
                 :style='c.patient.avatar ? "background:url(" + c.patient.avatar + ")" : ""'>
            </div>
          </div>

          <div class="patient-data">
            <div class="patient-data__details">
              <div class="patient-data__name">
                <h3>{{c.patient.firstName}} {{c.patient.middleName}} {{c.patient.lastName}}</h3>
              </div>
              <div class="patient-data__meta">
                <p><label>DOB:</label> {{c.patient.birthDate | formatDate('MMM DD, YYYY')}}</p>
                <p><label>AGE:</label> {{c.patient.birthDate | computeAge}}</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          {{c.gyneOrgan | decodeGyneOrgan}}
        </div>
        <div>
          {{c.organCondition | decodeGyneOrganCondition}}
        </div>
        <div>
          <smd-checkbox :id="c._id" :value="true"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "pogs-submissions__cases",
    props:{
      gyneCases: {}
    }
  }
</script>
